import gql from 'graphql-tag';

const ANSWER_OPEN = gql`
mutation answerOpen($tester: ID!, $question: ID!, $answer: String!) {
  answerOpenQuestion(participantId: $tester, campaignQuestionId: $question, answer: $answer)
}
`;

export default ANSWER_OPEN;